import { render, staticRenderFns } from "./Assesment.vue?vue&type=template&id=0112ac44"
import script from "./Assesment.vue?vue&type=script&lang=js"
export * from "./Assesment.vue?vue&type=script&lang=js"
import style0 from "./Assesment.vue?vue&type=style&index=0&id=0112ac44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports